import script from "./zendesk-chatbot.vue?vue&type=script&setup=true&lang=js"
export * from "./zendesk-chatbot.vue?vue&type=script&setup=true&lang=js"

import "./zendesk-chatbot.vue?vue&type=style&index=0&id=25cc568f&lang=css"

const __exports__ = script;

export default __exports__